import { render, staticRenderFns } from "./ResultConfig.vue?vue&type=template&id=703633a1&scoped=true"
import script from "./ResultConfig.vue?vue&type=script&lang=js"
export * from "./ResultConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703633a1",
  null
  
)

export default component.exports